import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { FadeUp, Overline } from "./Motion";

export const STEPS = [
  { t: "Análise do caso", d: "Você nos envia o contrato, a notificação ou o processo. Avaliamos a situação, os prazos e os riscos envolvidos." },
  { t: "Estratégia jurídica", d: "Definimos o caminho mais adequado: negociação, defesa no processo ou as duas frentes ao mesmo tempo." },
  { t: "Negociação com o banco", d: "Conduzimos o diálogo com a instituição financeira ou credor, buscando condições viáveis para você." },
  { t: "Solução e acompanhamento", d: "Formalizamos o acordo ou seguimos na defesa, mantendo você informado em cada etapa." },
];

const Step = ({ s, i }) => (
  <FadeUp delay={0.05} className="relative pl-16 md:pl-24 py-10 border-b border-[#D4AF37]/15 last:border-0">
    <span className="absolute left-0 top-[50px] h-[11px] w-[11px] rounded-full border border-[#D4AF37] bg-[#0B132B]" />
    <span className="absolute left-6 top-[46px] font-mono text-sm text-[#D4AF37]">0{i + 1}</span>
    <h3 className="font-display text-3xl md:text-4xl text-white">{s.t}</h3>
    <p className="mt-4 max-w-xl text-base text-[#C0C9DC] leading-relaxed">{s.d}</p>
  </FadeUp>
);

export const Process = ({ title = "Como atuamos" }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 70%", "end 60%"] });
  const scaleY = useTransform(scrollYProgress, [0, 1], [0, 1]);
  return (
    <section id="processo" ref={ref} data-testid="process-section" className="relative mx-auto max-w-[1360px] px-6 lg:px-10 py-24 md:py-36">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <Overline>Método</Overline>
            <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.02]">{title}</h2>
            <p className="mt-6 max-w-md text-base md:text-lg text-[#C0C9DC] leading-relaxed">Um processo claro, do primeiro contato à solução. Sem juridiquês, com transparência sobre cada passo.</p>
          </div>
        </div>
        <div className="relative lg:col-span-7">
          <span className="absolute left-[5px] top-0 bottom-0 w-px bg-[#D4AF37]/15" />
          <motion.span style={{ scaleY }} className="absolute left-[5px] top-0 bottom-0 w-px bg-[#D4AF37] origin-top" />
          {STEPS.map((s, i) => <Step key={s.t} s={s} i={i} />)}
        </div>
      </div>
    </section>
  );
};
